class HeroSimpleTabs {
  constructor(root) {
    this.root = root;
    this.navInner = root.querySelector('.hero-simple__tabs-nav-inner');

    if (!this.navInner) {
      return;
    }

    this.buttons = Array.from(
      this.navInner.querySelectorAll('.hero-simple__tab-btn'),
    );

    if (!this.buttons.length) {
      return;
    }

    this.handleClick = this.handleClick.bind(this);

    this.init();
  }

  init() {
    this.buttons.forEach((button) => {
      button.addEventListener('click', this.handleClick);
    });
  }

  handleClick(event) {
    const target = event.currentTarget;

    if (!target) {
      return;
    }

    this.buttons.forEach((button) => {
      button.classList.toggle(
        'hero-simple__tab-btn--active',
        button === target,
      );
    });
  }
}

if (typeof document !== 'undefined') {
  document.addEventListener('DOMContentLoaded', () => {
    const blocks = document.querySelectorAll('.hero-simple');

    if (!blocks.length) {
      return;
    }

    blocks.forEach((block) => {
      new HeroSimpleTabs(block);
    });
  });
}

